
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"16","height":"16"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#990ae3"}},[_c('path',{attrs:{"d":"M2.089 2l5.174 5.26a1.03 1.03 0 001.474 0l2.7-2.745-.012-.015 1.231-1.251.012.012L13.91 2z"}}),_c('path',{attrs:{"d":"M13.884 4.5l-1.228 1.251-3.18 3.231a2.066 2.066 0 01-2.953 0L.157 2.506A1.057 1.057 0 000 3.059v9.9a1.054 1.054 0 001.042 1.06h13.916A1.054 1.054 0 0016 12.964V3.059a1.065 1.065 0 00-.157-.553z"}})])])
          )
        }
      }
    